/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Verkehrsmittel`
};

const en_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Your means of transport`
};

const es_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Tu medio de transporte`
};

const fr_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Votre moyen de transport`
};

const it_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo mezzo di trasporto`
};

const nl_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `Uw vervoermiddel`
};

const pt_itinerary__options__travel_mode = /** @type {(inputs: {}) => string} */ () => {
	return `O seu meio de transporte`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__travel_mode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__options__travel_mode(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__options__travel_mode", locale)
	if (locale === "de") return de_itinerary__options__travel_mode(inputs)
	if (locale === "en") return en_itinerary__options__travel_mode(inputs)
	if (locale === "es") return es_itinerary__options__travel_mode(inputs)
	if (locale === "fr") return fr_itinerary__options__travel_mode(inputs)
	if (locale === "it") return it_itinerary__options__travel_mode(inputs)
	if (locale === "nl") return nl_itinerary__options__travel_mode(inputs)
	return pt_itinerary__options__travel_mode(inputs)
};